// Most of the consumer product prices come from api, but for those api doesn't serve, we add here
class ConsumerProducts {
	constructor() {
		this.orderItemNames = [
			{ orderItemCode: 'B2C_PACK_C4_BASIC', name: '6 gigan simmi' },
			{ orderItemCode: 'B2C_PACK_C4_UNLIMITED', name: '4G-100' },
			{ orderItemCode: 'B2C_PACK_C4_FAST', name: '4G-300' },
			{ orderItemCode: 'B2C_PACK_5G_300', name: '5G-300' },
			{ orderItemCode: 'B2C_PACK_5G_600', name: '5G-600' },
			{ orderItemCode: 'B2C_PACK_5G_1000', name: '5G-1000' }
		];
		this.voiceMailCostPerSimEuros = 1.5;
		this.shippingCostPerOrderEuros = 5;
		this.taxRate = 0.24;
	}
	getSimVoiceMailPrice = () => this.voiceMailCostPerSimEuros;
	getShippingPrice = () => this.shippingCostPerOrderEuros;
	getTaxRate = () => this.taxRate;

	getOrderItemName = (orderItemCode) => {
		return this.orderItemNames.find((item) => item.orderItemCode === orderItemCode)?.name;
	};
}

const consumerProducts = new ConsumerProducts();
Object.freeze(consumerProducts);

export default consumerProducts;
